import CardSection from '../sections/CardSection';
import SelectField from '../form/SelectField';
import InputField from '../form/InputField';

export default function IdentificationSection({
    data,
    generos,
    tiposDocumento,
    naturalezas,
    onChange,
    errors
}) {
    // Opciones para selects
    const tipoDocOptions = Array.isArray(tiposDocumento)
        ? tiposDocumento.map(item => ({ value: item.codigo, label: item.descripcion }))
        : [];
    const naturalezaOptions = Array.isArray(naturalezas)
        ? naturalezas.map(item => ({ value: item.codigo, label: item.descripcion }))
        : [];
    const generoOptions = Array.isArray(generos)
        ? generos.map(item => ({ value: item.codigo, label: item.descripcion }))
        : [];

    // Sólo permitir A–Z y 0–9, y forzar mayúsculas
    const handleDocumentoChange = (id, value) => {
        const sanitized = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        onChange(id, sanitized);
    };

    // Detectar si el tipo seleccionado es NIT o RUT por su value
    const selectedTipo = tipoDocOptions.find(opt => opt.value === data.tipoDocumento);
    const shouldShowDV = selectedTipo && ['N', 'R'].includes(selectedTipo.value)

    return (
        <CardSection icon="badge" title="Datos de Documento">
            {shouldShowDV ? (
                <>
                    {/* Fila 1: Tipo | Documento | DV */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <SelectField
                                id="tipoDocumento"
                                label="Tipo de Documento"
                                options={tipoDocOptions}
                                value={data.tipoDocumento}
                                onChange={onChange}
                                required
                                error={errors.tipoDocumento}
                            />
                        </div>
                        <div className="col">
                            <InputField
                                id="numeroDocumento"
                                label="Documento"
                                placeholder="Ingrese el número de documento"
                                uppercase
                                value={data.numeroDocumento}
                                onChange={handleDocumentoChange}
                                required
                                error={errors.numeroDocumento}
                            />
                        </div>
                        <div 
                            className="col-auto ms-auto"
                            style={{ maxWidth: '80px' }}
                        >
                            <InputField
                                id="digitoVerificacion"
                                label="DV"
                                value={data.digitoVerificacion}
                                disabled
                                onChange={onChange}
                                required
                                error={errors.digitoVerificacion}
                            />
                        </div>
                    </div>

                    {/* Fila 2: Naturaleza | Género */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <SelectField
                                id="naturaleza"
                                label="Naturaleza"
                                options={naturalezaOptions}
                                value={data.naturaleza}
                                onChange={onChange}
                                required
                                error={errors.naturaleza}
                            />
                        </div>
                        <div className="col-md-6">
                            <SelectField
                                id="genero"
                                label="Género"
                                options={generoOptions}
                                value={data.genero}
                                onChange={onChange}
                                required
                                error={errors.genero}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {/* Fila 1: Tipo | Documento */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <SelectField
                                id="tipoDocumento"
                                label="Tipo de Documento"
                                options={tipoDocOptions}
                                value={data.tipoDocumento}
                                onChange={onChange}
                                required
                                error={errors.tipoDocumento}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                id="numeroDocumento"
                                label="Documento"
                                placeholder="Ingrese el número de documento"
                                uppercase
                                value={data.numeroDocumento}
                                onChange={handleDocumentoChange}
                                required
                                error={errors.numeroDocumento}
                            />
                        </div>
                    </div>

                    {/* Fila 2: Naturaleza | Género */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <SelectField
                                id="naturaleza"
                                label="Naturaleza"
                                options={naturalezaOptions}
                                value={data.naturaleza}
                                onChange={onChange}
                                required
                                error={errors.naturalezas}
                            />
                        </div>
                        <div className="col-md-6">
                            <SelectField
                                id="genero"
                                label="Género"
                                options={generoOptions}
                                value={data.genero}
                                onChange={onChange}
                                required
                                error={errors.genero}
                            />
                        </div>
                    </div>
                </>
            )}
        </CardSection>
    );
}
